var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mall-price wrap"},[_c('h2',[_vm._v("Price")]),_c('p',{staticClass:"sub-title"},[_vm._v("制作料金")]),_c('p',[_vm._v(" 制作料金は、開発するシステムの内容によって異なります。基本的には、制作工数＝料金となるため、機能が多い、処理する情報が多い、システムの仕様が複雑など、手間がかかるほど料金は比例して高くなります。弊社実績として、小規模なシステムであれば、55万(税込)〜という案件もあります。システム化によって、人員削減や業務効率アップを実現できるため、投資による効果は必ず得られます。 ")])])
}]

export { render, staticRenderFns }